module.exports = __webpack_public_path__ + "static/03-466071560b5a64bee4a688206fc69878.jpg";